import React from 'react'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { camelizeKeys } from 'humps'

import type { PromptCheckoutProps } from 'App/Services/Mattermost/types'
import { useSelector } from 'APP/Hooks/redux'
import { useCreateCharge } from 'APP/Hooks/useCreateCharge'

import Checkout, {
  CHECKOUT_TYPE,
  CheckoutContext,
  CheckoutProps,
  FeePolicy,
} from 'APP/Components/Checkout'
import { handleCheckoutConfirm } from 'APP/Components/Checkout/helpers'

const ContentContainer = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
  gap: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

type SendAnswerFn = (reply: { payload: unknown; display: string }) => void

interface IntakeCheckoutProps extends PromptCheckoutProps {
  sendAnswer: SendAnswerFn
}

const IntakeCheckout = ({
  fee_policy,
  context,
  checkout_type,
  sendAnswer,
}: IntakeCheckoutProps) => {
  const { createCharge } = useCreateCharge()

  const episodeId = useSelector((state) => state.history.currentChannelId)
  const feePolicy = camelizeKeys(fee_policy) as FeePolicy
  const checkoutContext = camelizeKeys(context) as unknown as CheckoutContext<CHECKOUT_TYPE>
  const checkoutType = checkout_type as CHECKOUT_TYPE

  if (!episodeId) {
    return null
  }

  const onConfirm = async (ctx: CheckoutContext<CHECKOUT_TYPE>) => {
    await handleCheckoutConfirm({
      feePolicy,
      episodeId,
      checkoutType,
      checkoutContext: ctx,
      createCharge,
      sendAnswer,
    })
  }

  const checkoutProps = {
    feePolicy,
    context: checkoutContext,
    type: checkoutType,
    onConfirm,
  } as CheckoutProps

  return (
    <ContentContainer testID="INTAKE_CHECKOUT_CONTAINER">
      <Checkout {...checkoutProps} />
    </ContentContainer>
  )
}

export default IntakeCheckout
